const de = {
  // Navigation
  nav_home: "Heim",
  nav_explore: "Erkunden",
  nav_workspace: "Arbeitsplatz",
  ws_videos: "Videos",
  ws_untitled: "Video ohne Titel",
  // A generation that failed. The card carries these until it is dismissed.
  ws_failed_title: "Video fehlgeschlagen",
  ws_failed_refunded: "Ihr Guthaben wurde zurückgegeben",
  ws_failed_dismiss: "Zurückweisen",
  ws_failed_retry: "Versuchen Sie es erneut",
  ws_failed_retrying: "Beginnend mit …",
  ws_failed_banner_one: "Ein Video konnte nicht generiert werden",
  ws_failed_banner_many: "{n} Videos sind fehlgeschlagen",
  ws_failed_banner_body: "Es wurde nichts abgebucht – das Guthaben wurde Ihrem Konto wieder gutgeschrieben. Versuchen Sie es noch einmal oder wählen Sie ein anderes Thema.",
  ws_empty_title: "Hier ist noch nichts.",
  ws_empty_body: "Jedes von Ihnen erstellte Video wird hier angezeigt, das neueste zuerst.",
  ws_generate: "Erzeugen",
  ws_composer_placeholder: "Beschreiben Sie eine Lektion",
  ws_placeholder_hw: "Benennen Sie die Aufgabe… (optional)",
  ws_placeholder_lecture: "Benennen Sie die Vorlesung… (optional)",
  ws_placeholder_self_study: "Was möchtest du studieren?",
  nav_search: "Videos suchen...",
  nav_search_yours: "Durchsuchen Sie Ihre Videos...",
  nav_notifications: "Benachrichtigungen",
  nav_mark_all_read: "Alles als gelesen markieren",
  nav_no_notifications: "Noch keine Benachrichtigungen",
  nav_no_notifications_sub: "Wir benachrichtigen Sie, wenn Ihre Videos fertig sind",
  nav_upgrade: "Upgrade",
  nav_billing: "Abrechnung",
  nav_settings: "Einstellungen",
  nav_contact: "Kontaktieren Sie uns",
  nav_api: "API",
  nav_sign_out: "Abmelden",
  nav_just_now: "Soeben",
  nav_minutes_ago: "Vor {n}m",
  nav_hours_ago: "Vor {n}h",
  nav_days_ago: "Vor {n}d",
  nav_used_this_month: "{used} von {cap} wurden diesen Monat verwendet",
  // locale file, and this one is the obvious thing to reach for if a weekly bucket returns.
  nav_used_today: "{used} von {limit} wurden diese Woche verwendet",
  nav_free_daily: "4 kostenlose Videos pro Woche",
  // Settings
  settings_title: "Einstellungen",
  settings_profile: "Profil",
  settings_change_avatar: "Avatar ändern",
  settings_cancel: "Stornieren",
  settings_choose_wizard: "Wählen Sie Ihren Assistenten",
  settings_display_name: "Anzeigename",
  settings_your_name: "Ihr Name",
  settings_save: "Speichern",
  settings_saving: "Sparen...",
  settings_saved: "Gespeichert",
  settings_save_failed: "Speichern fehlgeschlagen",
  settings_email: "E-Mail",
  settings_notifications: "Benachrichtigungen",
  settings_email_notif: "E-Mail-Benachrichtigungen",
  settings_email_notif_desc: "Erhalten Sie Updates und Ankündigungen per E-Mail",
  settings_language: "Sprache",
  settings_language_desc: "Wählen Sie die Sprache für die App und den Videokommentar",
  settings_data_title: "Ihre Daten",
  settings_data_desc: "Laden Sie eine Kopie der mit Ihrem Konto verknüpften persönlichen Daten herunter – einschließlich Ihres Profils, Ihrer Videos, Kurse, Sitzungen und Supportnachrichten. Interne Systemprotokolle und abgeleitete Verarbeitungsdaten sind nicht enthalten.",
  settings_data_download: "Laden Sie meine Daten herunter",
  settings_data_exporting: "Vorbereiten…",
  settings_danger: "Gefahrenzone",
  settings_delete_account: "Konto löschen",
  settings_delete_desc: "Löschen Sie Ihr Konto und alle damit verbundenen Daten endgültig. Diese Aktion kann nicht rückgängig gemacht werden.",
  settings_delete_confirm: "Dadurch werden Ihr Konto und alle Ihre Daten dauerhaft gelöscht. Geben Sie zur Bestätigung {keyword} ein.",
  settings_delete_placeholder: "Geben Sie zur Bestätigung „LÖSCHEN“ ein",
  settings_permanently_delete: "Endgültig löschen",
  settings_deleting: "Löschen...",
  explore_watch_now: "Jetzt ansehen",
  // One pair of strings per scene; the eyebrow and the button are shared.
  explore_no_preview: "Keine Vorschau",
  explore_no_videos: "Noch keine Videos verfügbar. Schauen Sie bald wieder vorbei!",
  explore_featured_courses: "Empfohlene Kurse",
  course_lesson_count: "{n, plural, one {# lesson} other {# lessons}}",
  course_back_to_explore: "Zurück zu „Erkunden“.",
  course_not_found: "Dieser Kurs ist nicht verfügbar.",
  // Home Page
  home_hero: "Lerne alles,",
  home_hero_accent: "visuell",
  home_placeholder: "Was möchten Sie lernen oder lösen?",
  home_extracting: "Fragen extrahieren...",
  home_videos_generated: "{n, plural, one {# Video} other {# Videos}} werden generiert",
  home_credits: "{n, plural, one {# Credit} other {# Credits}}",
  home_remaining: "noch in diesem Monat übrig",
  home_enter_prompt: "Bitte geben Sie ein, was Sie lernen oder lösen möchten",
  home_popular: "Beliebte Lektionen",
  home_from_community: "Aus der Community",
  home_community_sub: "Sehen Sie, was die Schüler schaffen",
  home_tips_label: "Vom Magi-Zauberer",
  home_tips_title: "Tipps & Tricks",
  home_tip1_title: "Werden Sie konkret",
  home_tip1_desc: "Geben Sie nicht einen ganzen Betreff ein. Wählen Sie eine Idee, ein Konzept, eine Frage.",
  home_tip1_example: "Wie die DNA-Replikation in eukaryotischen Zellen funktioniert",
  home_tip2_title: "Sagen Sie, für wen es ist",
  home_tip2_desc: "Eine Erklärung in der Mittelschule sieht völlig anders aus als eine Vorlesung an der Universität.",
  home_tip2_example: "Erklären Sie Ableitungen für jemanden, der gerade Algebra gelernt hat",
  home_tip3_title: "Sagen Sie Magi, was Sie wollen",
  home_tip3_desc: "Beispiele, Schritt-für-Schritt-Anleitungen, reale Anwendungen – sagen Sie es einfach und Magi wird Ihnen folgen.",
  home_tip3_example: "Der Wasserkreislauf mit Beispielen aus der Praxis und einer Zusammenfassung",
  home_tip_try: "Versuchen Sie etwas wie",
  home_proven_social: "Folgen Sie uns auf Instagram",
  home_ig_desc_1: "Über",
  home_ig_followers: "55.000 Follower",
  home_ig_desc_2: "Schauen Sie sich jeden Tag unsere Mathematik- und Naturwissenschaftsvideos auf Instagram an. Diese Rollen werden mit dem gleichen Motor hergestellt, den Sie hier verwenden.",
  home_view_profile: "Profil ansehen",
  home_subscribe_now: "Jetzt abonnieren",
  home_sub_monthly: "Monatlich",
  home_sub_yearly: "Jährlich",
  // goes false the moment either price moves, on the surface where that matters most.
  home_sub_yearly_save: "Sparen Sie {pct} %",
  home_sub_per_month: "/ Monat",
  home_sub_billed_monthly: "jeden Monat ${amount} in Rechnung gestellt",
  home_sub_processing: "Verarbeitung...",
  home_sub_no_commitment: "Keine Verpflichtung. Jederzeit kündbar.",
  home_sub_secured: "Gesichert durch Stripe",
  home_sub_headline: "Schalten Sie mehr frei mit {plan}",
  home_sub_due_now: "Jetzt fällig",
  home_sub_trial_label: "{days}-Tage voller Zugriff",
  // choosing the plan directly is owed exactly what a trialist is owed.
  home_sub_monthly_terms: "Für ${amount} Videos in diesem Monat werden Ihnen heute {n} $ in Rechnung gestellt. Am {date} verlängert es sich um einen Betrag von ${amount}/Monat, es sei denn, Sie kündigen vorher – die Kündigung ist jederzeit über die Abrechnung möglich.",
  // frequency, states that it happens automatically, and says where to cancel.
  home_sub_trial_terms: "Ihnen werden heute ${trial} $ für {days} Tage Vollzugriff berechnet, maximal {n} Videos. Die Testversion läuft nicht zum Preis von ${trial} weiter – am {date} wird sie automatisch zu {planName} zum Preis von ${plan} pro Monat ({full} videos), und danach wird ${plan} jeden Monat berechnet, bis Sie kündigen. Sie können jederzeit über die Abrechnung stornieren.",
  home_sub_card: "Kredit- oder Debitkarte",
  home_sub_billed_once_yearly: "einmal im Jahr ${amount} in Rechnung gestellt",
  home_sub_billed_trial: "${amount} für {days} Tage in Rechnung gestellt und dann jeden Monat um ${renews} verlängert",
  home_sub_switch_plan: "Suchen Sie stattdessen nach {plan}?",
  home_sub_replaces_plan: "Ersetzt Ihren {plan}-Plan. Ihr Rechnungsdatum bleibt gleich – bei einem höheren Betrag wird die Differenz jetzt berechnet, bei einem niedrigeren Betrag beginnt die nächste Verlängerung.",
  home_sub_change_now: "Sie sind jetzt auf {plan} – {amount} für die Differenz berechnet.",
  home_sub_change_later: "Sie wechseln am {date} zu {plan}. Heute wird nichts berechnet.",
  // the allowance changed; this one cannot.
  home_sub_feature_videos_n: "{n} Videos pro Monat",
  // Pricing Page
  pricing_title: "Aktualisieren Sie Ihren Plan",
  pricing_monthly: "Monatlich",
  pricing_yearly: "Jährlich",
  pricing_save: "Sparen Sie 17 %",
  pricing_best_value: "Bestes Preis-Leistungs-Verhältnis",
  pricing_your_plan: "Ihr aktueller Plan",
  pricing_get_started: "Fangen Sie an",
  pricing_processing: "Verarbeitung...",
  pricing_per_month: "/Monat",
  pricing_billed_yearly: "In Rechnung gestellt: ${amount}/Jahr",
  pricing_videos_month: "{n, plural, one {# Video} other {# Videos}}/Monat",
  pricing_manage_cancel: "Verwalten oder stornieren",
  pricing_manage_unavailable: "Wir konnten kein Abonnement zum Verwalten finden. Bitte kontaktieren Sie uns, wir klären das.",
  pricing_opening: "Öffnung...",
  billing_autorenew_monthly: "Verlängert sich automatisch um ${amount}/Monat, bis Sie kündigen.",
  billing_autorenew_yearly: "Verlängert sich automatisch um ${amount}/Jahr, bis Sie kündigen.",
  billing_autorenews_on: "Automatische Verlängerung am {date} · jederzeit kündbar",
  pricing_secured: "Gesichert durch Stripe",
  pricing_login_required: "Bitte melden Sie sich an, um sich anzumelden",
  pricing_auth_error: "Fehler bei der Benutzerauthentifizierung. Bitte versuchen Sie, sich abzumelden und wieder anzumelden.",
  pricing_feature_pdf: "PDF- und Bildextraktion",
  pricing_feature_quality: "Hochwertigeres Modell",
  pricing_feature_speed: "Schnellere Generationszeit",
  pricing_feature_study: "Lernsitzungen",
  pricing_free_hint: "Derzeit im Free-Plan",
  // Billing Page
  billing_title: "Abrechnung",
  billing_current_plan: "Aktueller Plan",
  billing_payment_failed_title: "Ihr Plan ist pausiert",
  billing_payment_failed_body: "Wir konnten {amount} nicht einziehen, daher ist Ihr Plan pausiert. Aktualisieren Sie Ihre Karte, um sie erneut zu starten. Wir werden es auch weiterhin versuchen.",
  billing_payment_failed_cta: "Zahlung korrigieren",
  billing_change_plan: "Plan ändern",
  billing_invoices: "Rechnungen",
  billing_loading: "Rechnungen werden geladen...",
  billing_no_invoices: "Noch keine Rechnungen",
  billing_date: "Datum",
  billing_amount: "Menge",
  billing_status: "Status",
  billing_invoice: "Rechnung",
  billing_view: "Sicht",
  // Contact Page
  contact_title: "Kontaktieren Sie uns",
  contact_placeholder: "Wie können wir helfen?",
  contact_sent_desc: "Wir werden uns so schnell wie möglich bei Ihnen melden.",
  contact_signin: "Bitte melden Sie sich an, um den Support zu kontaktieren.",
  // Generation Queue
  queue_title: "Warteschlange",
  queue_active: "{n} aktiv",
  queue_generating: "{n} generieren",
  queue_ready: "Bereit zum Zuschauen",
  queue_in_queue: "Wartet in der Warteschlange...",
  queue_almost_ready: "Fast fertig...",
  queue_seconds_left: "{n}s übrig",
  queue_minutes_left: "{m}m {s}s übrig",
  queue_watch_now: "Jetzt ansehen",
  queue_waiting: "Warten in der Warteschlange...",
  queue_empty: "Keine Videos in der Warteschlange",
  queue_empty_sub: "Erstellen Sie ein Video, um es hier zu sehen",
  queue_clear: "Alles löschen",
  queue_total: "{n} insgesamt",
  queue_first_time: "Ihr Video wird generiert",
  queue_first_time_sub: "Normalerweise ca. 2 Min. Sobald es fertig ist, ertönt ein Signalton.",
  // Session Expired
  session_expired: "Sitzung abgelaufen",
  session_expired_desc: "Ihre Sitzung ist aus Sicherheitsgründen abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
  // Cookie Banner
  cookie_text: "Wir verwenden Cookies, um den Website-Verkehr zu analysieren und Ihr Erlebnis zu verbessern. Standardmäßig sind nur unbedingt erforderliche Cookies gesetzt.",
  cookie_learn_more: "Erfahren Sie mehr",
  cookie_accept: "Akzeptiere alles",
  cookie_reject: "Unwesentliches ablehnen",
  // Create Project Modal
  create_new_project: "Neues Projekt",
  create_extracting: "Extrahieren...",
  create_select_problems: "Wählen Sie Probleme aus",
  create_select_topics: "Wählen Sie Themen aus",
  create_new_video: "Neues Video",
  create_new_hw: "Neues Hausaufgabenprojekt",
  create_new_lecture: "Neues Vorlesungsprojekt",
  create_new_self_study: "Neues Projekt",
  create_video: "Video",
  create_homework: "Hausaufgaben",
  create_lecture: "Vortrag",
  create_self_study: "Projekt",
  create_video_sub: "Erstelle ein Video",
  create_hw_sub: "Hausaufgaben hochladen",
  create_lecture_sub: "Laden Sie Folien hoch",
  create_self_study_sub: "Wählen Sie Ihre Themen",
  create_video_prompt: "Was soll das Video erklären?",
  create_project_title: "Projekttitel",
  create_video_hint: "Dieser wird sowohl als Titel als auch als Aufforderung für Ihr Video verwendet.",
  create_drop_hw: "Geben Sie hier Ihre Hausaufgaben ab",
  create_drop_lecture: "Legen Sie Ihre Vorlesungsfolien hier ab",
  create_file_types: "PDF, PNG, JPG, HEIC",
  // Shown over the composer while a file is being dragged onto it.
  composer_drop_hint: "Lassen Sie es fallen, um ein Projekt zu starten",
  create_reading_hw: "Lesen Sie Ihre Hausaufgaben",
  create_reading_lecture: "Ich lese Ihren Vortrag",
  create_finding_problems: "Probleme finden und extrahieren...",
  create_finding_topics: "Themen extrahieren...",
  create_add_video: "Fügen Sie ein weiteres Video hinzu",
  create_add_more_files: "Fügen Sie weitere Dateien hinzu",
  create_starting: "Generation starten...",
  create_generate_video: "Video generieren \u00B7 1 Credit",
  create_generate_n: "{n, plural, one {# Video} other {# Videos}} generieren \u00B7 {n, plural, one {# Credit} other {# Credits}}",
  create_create_project: "Projekt erstellen \u00B7 {n, plural, one {# Credit} other {# Credits}}",
  create_no_problems: "Konnte keine Probleme feststellen. Versuchen Sie es mit einem klareren Foto oder einer anderen Seite.",
  create_no_topics: "Konnte keine Themen finden. Versuchen Sie es mit einem klareren Foto oder einer anderen Datei.",
  create_error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
  create_extract_daily_limit: "Das sind alle Unterlagen für heute. Morgen mehr.",
  create_video_topic_placeholder: "Video {n} Thema, z. B. „Eigenwerte und Eigenvektoren“",
  video_share: "Aktie",
  // and made the two indistinguishable.
  video_followup_placeholder: "Folgevideo generieren...",
  video_chip_simpler: "Erklären Sie es einfacher",
  video_chip_harder: "Schwierigeres Beispiel",
  video_chip_real_world: "Realer Einsatz",
  // spends a credit generating a new one.
  video_ask_title: "Fragen Sie nach diesem Video",
  video_ask_cta: "Chatten Sie darüber",
  video_ask_placeholder: "Eine Frage stellen...",
  video_ask_thinking: "Denken...",
  video_ask_close: "Schließen",
  video_ask_chip_explain: "Erklären Sie diesen Teil",
  video_ask_chip_example: "Geben Sie ein Beispiel",
  video_ask_chip_why: "Warum funktioniert das?",
  video_ask_limit_reached: "Sie haben das heutige Fragenlimit erreicht. Es wird morgen zurückgesetzt.",
  video_up_next: "Als nächstes",
  video_no_suggested: "Noch keine vorgeschlagenen Videos",
  video_untitled: "Video ohne Titel",
  video_created_recently: "Kürzlich erstellt",
  video_just_now: "Soeben",
  video_minutes_ago: "vor {n, plural, one {# Minute} other {# Minuten}}",
  video_hours_ago: "vor {n, plural, one {# Stunde} other {# Stunden}}",
  video_days_ago: "vor {n, plural, one {# Tag} other {# Tagen}}",
  video_weeks_ago: "vor {n, plural, one {# Woche} other {# Wochen}}",
  video_months_ago: "vor {n, plural, one {# Monat} other {# Monaten}}",
  video_years_ago: "vor {n, plural, one {# Jahr} other {# Jahren}}",
  video_unknown_date: "Unbekanntes Datum",
  video_download_error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
  // Search Results
  search_no_results: "Keine Ergebnisse gefunden",
  search_no_results_for: "Keine Ergebnisse für „{query}“ gefunden",
  search_all_videos: "Alle Videos durchsuchen",
  search_enter_term: "Geben Sie einen Suchbegriff ein, um Videos zu finden",
  search_retry: "Versuchen Sie die Suche erneut",
  auth_continue_google: "Weiter mit Google",
  // sentence, and the box ships unticked — a pre-ticked box is not consent.
  home_sub_waiver: "Starten Sie gleich meinen Zugang. Ich verstehe, dass dies bedeutet, dass ich auf mein Widerrufsrecht von {days}-Tagen und eine Rückerstattung verzichte.",
  home_sub_waiver_required: "Bitte bestätigen Sie dies, um fortzufahren.",
  home_sub_agree_prefix: "Indem Sie fortfahren, stimmen Sie unseren zu",
  // floor is 13 — if that clause changes, this string and DIGITAL_CONSENT_AGE move with it.
  auth_min_age: "Sie müssen mindestens {age} sein, um Magi nutzen zu können.",
  auth_agree_prefix: "Mit Ihrer Anmeldung stimmen Sie unserem zu",
  auth_terms: "Nutzungsbedingungen",
  auth_and: "Und",
  auth_privacy: "Datenschutzrichtlinie",
  auth_email_optin: "Schicken Sie mir Tipps und Updates",
  // Auth modal (Google + email/password)
  auth_signin_title: "Melden Sie sich bei Magi an",
  auth_signin_desc: "Machen Sie dort weiter, wo Sie aufgehört haben.",
  auth_signup_title: "Erstellen Sie Ihr Konto",
  auth_signup_desc: "Der Start ist kostenlos, keine Karte erforderlich.",
  auth_or: "oder",
  auth_continue_email: "Weiter mit E-Mail",
  auth_signing_in: "Anmelden…",
  auth_working: "Nur eine Sekunde…",
  auth_email_placeholder: "E-Mail-Adresse",
  auth_password_placeholder: "Passwort",
  auth_signin_submit: "anmelden",
  auth_signup_submit: "Benutzerkonto erstellen",
  auth_no_account: "Neu hier?",
  auth_signup_link: "Ein Konto erstellen",
  auth_have_account: "Sie haben bereits ein Konto?",
  auth_signin_link: "anmelden",
  auth_forgot_password: "Passwort vergessen?",
  auth_reset_title: "Setzen Sie Ihr Passwort zurück",
  auth_reset_desc: "Wir senden Ihnen per E-Mail einen Link zum Erstellen eines neuen Kontos.",
  auth_reset_submit: "Link zum Zurücksetzen senden",
  auth_reset_sent: "Überprüfen Sie Ihre E-Mails auf den Link zum Zurücksetzen.",
  auth_back_to_signin: "Zurück zur Anmeldung",
  // Full-screen wall shown to a signed-in account that has not confirmed its address.
  verify_wall_title: "Bestätigen Sie Ihre E-Mail, um fortzufahren",
  verify_wall_desc: "Wir haben einen Bestätigungslink an {email} gesendet. Klicken Sie darauf und kehren Sie dann hierher zurück.",
  verify_wall_check: "Ich habe es bestätigt",
  verify_wall_checking: "Überprüfung...",
  verify_wall_still_unverified: "Noch nicht bestätigt. Klicken Sie auf den Link in der E-Mail und versuchen Sie es erneut.",
  verify_wall_resend: "Senden Sie den Link erneut",
  verify_wall_resent: "Gesendet. Überprüfen Sie Ihren Posteingang und Ihren Spam-Ordner.",
  verify_wall_wrong_account: "Falsches Konto? Abmelden",
  // The screen the confirmation LINK lands on, replacing Firebase's unbranded handler page.
  verify_action_working_title: "Bestätigung Ihrer E-Mail",
  verify_action_working_desc: "Einen Moment.",
  verify_action_done_title: "Sie sind bereit",
  verify_action_done_desc: "Ihre E-Mail wurde bestätigt. Willkommen bei Magi.",
  verify_action_done_cta: "Fangen Sie an zu lernen",
  verify_action_failed_title: "Dieser Link hat nicht funktioniert",
  verify_action_failed_desc: "Möglicherweise wurde es bereits verwendet oder es ist abgelaufen. Gehen Sie zurück und schicken Sie sich ein neues.",
  verify_action_failed_cta: "Zurück zu Magi",
  // Wall copy — each surface names what signing in actually gets you
  auth_watch_title: "Melden Sie sich an, um zuzuschauen",
  auth_watch_desc: "Erstellen Sie ein kostenloses Konto, um dieses Video abzuspielen.",
  auth_watch_ready_title: "Ihr Video ist fertig",
  auth_watch_ready_desc: "Melden Sie sich an, um es anzusehen – es wird in Ihrem Konto gespeichert.",
  // rather than saying "sign in" twice — the specific ask converts, the generic one nags.
  auth_download_title: "Zum Herunterladen anmelden",
  auth_download_desc: "Erstellen Sie ein kostenloses Konto, um dieses Video zu speichern.",
  auth_ask_title: "Melden Sie sich an, um zu fragen",
  auth_ask_desc: "Erstellen Sie ein kostenloses Konto, um Fragen zu diesem Video zu stellen.",
  auth_browse_title: "Melden Sie sich an, um zu stöbern",
  auth_browse_desc: "Erstellen Sie ein kostenloses Konto, um jede Lektion zu erkunden.",
  auth_workspace_title: "Melden Sie sich an, um Ihre Arbeit zu sehen",
  auth_workspace_desc: "Ihre Lektionen und Projekte sind in Ihrem Konto verfügbar.",
  auth_generate_title: "Melden Sie sich an, um weiter zu erstellen",
  auth_generate_desc: "Kostenlose Konten erhalten jeden Tag ein Video.",
  video_restricted: "Dieses Video ist noch nicht verfügbar.",
  // Share sheet
  share_title: "Teilen Sie dieses Video",
  share_desc_mobile: "Veröffentlichen Sie es in Ihrer Story, senden Sie es an einen Freund oder kopieren Sie den Link.",
  share_desc_desktop: "Kopieren Sie den Link oder laden Sie das Video zum Posten von Ihrem Telefon herunter.",
  share_to_apps: "Auf Instagram und mehr teilen",
  share_copy_link: "Link kopieren",
  share_copied: "Link kopiert",
  share_download: "Video herunterladen",
  share_preparing: "Wir bereiten es vor …",
  share_watermark_note: "Geteilte Videos umfassen magiacademy.com",
  // Welcome Modal (post-signup)
  welcome_title: "Willkommen bei Magi",
  welcome_subtitle: "Sie haben 4 kostenlose Videos zum Starten.",
  welcome_optin_reward: "+1 kostenloses Video",
  welcome_continue: "Weitermachen",
  age_gate_continue: "Weitermachen",
  age_gate_saving: "Sparen...",
  // Landing Page
  landing_hero: "Geben Sie ein Thema ein.",
  landing_hero2: "Holen Sie sich eine Videolektion.",
  landing_subtitle: "Magi verwandelt jedes Thema in wenigen Minuten in ein wunderschön animiertes, kommentiertes Video. Kein Filmen, kein Schnitt, kein Fachwissen erforderlich.",
  landing_signup_google: "Melden Sie sich bei Google an",
  landing_signing_in: "Anmelden...",
  landing_chat_bubble: "Wie nutzt GPS die Relativitätstheorie?",
  landing_stats_title: "Lernende auf der ganzen Welt vertrauen darauf",
  landing_stat_videos: "3.000+",
  landing_stat_videos_desc: "Videos generiert",
  landing_stat_languages_desc: "Sprachen",
  landing_stat_speed: "~1 Min",
  landing_stat_speed_desc: "Generationszeit",
  landing_feature_lecture_title: "Hinterlassen Sie Ihre Vorlesungsunterlagen und holen Sie sich Videos",
  landing_feature_lecture_desc: "Laden Sie Ihre Folien oder Notizen hoch. Magi greift jedes Thema heraus und erstellt für jedes eine Videoerklärung.",
  landing_feature_hw_title: "Du steckst bei den Hausaufgaben fest? Laden Sie es hoch.",
  landing_feature_hw_desc: "Legen Sie einen Problemsatz ab, und Magi extrahiert jedes Problem und führt Sie dann in einem Schritt-für-Schritt-Video durch die Lösung.",
  landing_feature_chat_title: "Stellen Sie Fragen, während Sie zuschauen",
  landing_feature_chat_desc: "Zu jedem Video gehört ein KI-Tutor, mit dem Sie chatten können. Stellen Sie weitere Fragen, erhalten Sie ausführlichere Erklärungen oder fordern Sie ein neues Video zu einem bestimmten Teil an, den Sie besser verstehen möchten.",
  landing_feature_lang_title: "Lernen Sie in Ihrer Sprache",
  landing_feature_lang_desc: "Magi generiert Videos in Englisch, Spanisch, Hindi, Chinesisch, Japanisch und mehr. Geben Sie Ihr Thema in einer beliebigen Sprache ein und erhalten Sie eine vollständig kommentierte Lektion in dieser Sprache zurück.",
  landing_cta_title: "Beginnen Sie in Sekundenschnelle mit dem Lernen",
  landing_cta_google: "Weiter mit Google",
  // Onboarding Bubbles
  onboarding_step1: "Dies ist kein Chatbot. Geben Sie ein Thema ein und ich erstelle eine vollständige Videolektion für Sie!",
  onboarding_step2: "Oder senden Sie ein PDF oder ein Foto. Ich verwandle jedes Problem in eine Schritt-für-Schritt-Videolösung",
  onboarding_step3: "Klicken Sie auf „Los“ und Ihr Video wird in die Warteschlange aufgenommen. Sie können während des Renderns weiter surfen!",
  onboarding_generating: "Dies ist Ihre Lektion, die ein paar Minuten dauert. Stöbern Sie weiter, wenn Sie möchten. Es wird genau hier landen, wenn es fertig ist.",
  onboarding_skip: "Überspringen",
  onboarding_next: "Nächste",
  onboarding_done: "Habe es!",
  // Generating Cards Row
  generating_label: "Generieren",
  // Lecture Session (Self Study)
  lecture_loading: "Laden...",
  lecture_fallback_title: "Vortrag",
  lecture_building: "Bauvideo...",
  lecture_building_time: "Dies dauert normalerweise 2-4 Minuten",
  lecture_failed: "Die Videogenerierung ist fehlgeschlagen",
  lecture_no_video: "Noch kein Video",
  lecture_followup: "Nachverfolgen",
  lecture_now_playing: "Jetzt spielen",
  lecture_tab_videos: "Videos",
  lecture_tab_chat: "Chatten",
  lecture_chat_empty: "Fragen Sie etwas zu diesem Thema",
  lecture_chat_chip1: "Einfach erklären",
  lecture_chat_chip2: "Geben Sie ein Beispiel",
  lecture_chat_chip3: "Warum ist das nützlich?",
  lecture_chat_placeholder: "Fragen Sie nach diesem Thema...",
  lecture_followup_placeholder: "Fügen Sie ein Folgevideo hinzu...",
  lecture_chat_error: "Tut mir leid, das konnte ich nicht verarbeiten. Versuchen Sie es erneut.",
  lecture_chat_generic_error: "Etwas ist schief gelaufen. Versuchen Sie es erneut.",
  // Home shortcuts — square cards that jump to the Workspace composer preset to a mode
  home_sc_hw_title: "Hausaufgaben PDF",
  home_sc_hw_desc: "Laden Sie einen Aufgabensatz hoch und erhalten Sie zu jeder Frage ein bearbeitetes Video",
  home_sc_lecture_title: "Vorlesungs-PDF",
  home_sc_lecture_desc: "Verwandeln Sie Folien oder Notizen in eine Reihe von Lektionen",
  home_sc_course_title: "Erstellen Sie einen Kurs",
  home_sc_course_desc: "Planen Sie eine Unterrichtsfolge zu einem Thema",
  // Misc
  generic_error: "Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.",
  loading: "Laden...",
};

export default de;
